<template>
    <div>

        <!-- Table -->

        <trax-ui-card-plain-header-with-actions :title="lang.polaris.training.competency_domains" :actions="card_actions" :bus="bus">
            <trax-ui-ajax-struct-table-with-actions :id="id" :bus="bus" :endpoint="endpoint" 
                :index-id="listId" drag="1"
                index-key="list_id" :multilevel="false">
            </trax-ui-ajax-struct-table-with-actions>
        </trax-ui-card-plain-header-with-actions>

        <!-- Editing modal -->

        <trax-ui-modal-default :id="id+'-edit'" :bus="bus">
            <trax-training-competency-domains-edit-form :id="id+'-edit'" :toastr-id="id+'-toastr'" :bus="bus" :endpoint="endpoint" :list-id="listId">
            </trax-training-competency-domains-edit-form>
        </trax-ui-modal-default>

        <!-- Delete confirm modal -->

        <trax-ui-modal-confirm :id="id+'-delete'" :title="lang.polaris.form.deletion" :bus="bus">
            {{ lang.polaris.form.confirm_delete_q }}
        </trax-ui-modal-confirm>

        <!-- Toastr -->

        <trax-ui-toastr :id="id+'-toastr'" :bus="bus" passed-label="1" no-progress="1">
        </trax-ui-toastr>
    
    </div>
</template>

<script>
    export default {
    
        props: {
            id: {default: 'trax-training-competency-domains'},
            listId: null
        },
    
        data: function() {
            return {
                lang: lang,
                endpoint: app_url+"polaris/api/front/competency-domains",
                card_actions: [
                    { icon: 'add_box', event: this.id+'-edit-create' }
                ],
                bus: new Vue()
            }
        }
    }
</script>
